import { isObject } from 'lodash';
import { isNumeric } from 'mathjs';

// mathjs isNumeric throws on plain objects and returns an array for arrays
// (always truthy), so only pass it primitive values and require a strict true.
export const isNumericValue = (value: unknown): boolean =>
  !isObject(value) && isNumeric(value as any) === true;

// Drawer configs have sent the cloud column as both 'Cloud' and 'cloud'.
export const isCloudHeader = (header?: string): boolean =>
  header?.toLowerCase() === 'cloud';
